export const environment = {
	production: true,
  clientAuthUrl: 'https://auth.lightwaverf.com/v2/lightwaverf/autouserlogin/lwapps',
  publicApi: {
    url: 'https://publicapi.lightwaverf.com/v3/data/pass',
    apiKey: 'use access token',
    demoUrl: 'https://publicapi.lightwaverf.com/demo/data/pass/'
  },
	wsConfig: {
    url: 'wss://v1-linkplus-app.lightwaverf.com'
	},
	studioConfig: {
    wsUrl: 'wss://v1-linkplus-app.lightwaverf.com',
    wsUrlProd: 'wss://v1-linkplus-app.lightwaverf.com',
		clientAuthUrl: 'https://auth.lightwaverf.com/v2/lightwaverf/autouserlogin/lwapps/',
	}
};
